import { useTranslation } from 'next-i18next';
import componentStyles from './page-header-desktop.style';
import { useMemo } from 'react';
import { getThemeProperties } from '@bridebook/web/lib/wedding-website/utils';
import { useRsvpData } from '../guest-rsvp.context';
import { Box, Container } from '@bridebook/ui';
import { BridebookLogo } from '@bridebook/ui/src/icons/dynamic';

const PageHeaderDesktop: React.FC = () => {
  const { t } = useTranslation('weddingWebsite');
  const { theme, weddingWebsite } = useRsvpData();

  const partners = weddingWebsite.wedding.partners;

  const themeProperties = useMemo(() => getThemeProperties(theme), [theme]);

  const styles = componentStyles(themeProperties);

  return (
    <Box style={styles.wrapper}>
      <Container style={styles.container}>
        <Box style={styles.title}>
          {t('rsvp.pageHeaderDesktop.title', {
            partners,
          })}{' '}
          <Box style={styles.divider} />
          {t('rsvp.pageHeaderDesktop.rsvp')}
        </Box>
        <Box>
          <a href="/">
            <BridebookLogo color="indigoCrush" width={92} />
          </a>
        </Box>
      </Container>
    </Box>
  );
};

export default PageHeaderDesktop;
